export const addTransactionFields = [
  {
    title: "Invoice / Payment Details",
    fields: [
      {
        divClass: "",
        label: "Name of Firm/Vendor/Particulars",
        htmlFor: "firm_name",
        inputProps: {
          id: "firm_name",
          name: "firm_name",
          type: "text",
          placeholder: "Enter Firm/Vendor/Particulars",
          disabled: false,
          required: true,
          validation: {
            required: true,
            message: "Firm name is required.",
          },
        },
      },
      {
        divClass: "",
        label: "Type of Investment",
        htmlFor: "investment_type",
        inputProps: {
          id: "investment_type",
          name: "investment_type",
          type: "text",
          placeholder: "Enter Investment Type",
          disabled: false,
          required: true,
          validation: {
            required: true,
            message: "Investment type is required.",
          },
        },
      },
      {
        divClass: "",
        label: "GST Number",
        htmlFor: "gst_number",
        inputProps: {
          id: "gst_number",
          name: "gst_number",
          type: "text",
          placeholder: "Enter GST Number",
          disabled: false,
          required: true,
          maxLength: 15,
          validation: {
            required: true,
            pattern:
              /^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}Z[0-9A-Z]{1}$/,
            message: "Enter a valid GST number.",
          },
        },
      },
      {
        divClass: "",
        label: "Invoice Number",
        htmlFor: "invoice_number",
        inputProps: {
          id: "invoice_number",
          name: "invoice_number",
          type: "text",
          placeholder: "Enter number",
          disabled: false,
          required: true,
          validation: {
            required: true,
            message: "Invoice number is required.",
          },
        },
      },
      {
        divClass: "",
        label: "State",
        htmlFor: "state",
        inputProps: {
          id: "state",
          name: "state",
          type: "select",
          options: [{ label: "Uttarakhand", value: "uttarakhand" }],
          disabled: false,
          required: true,
        },
      },
      {
        divClass: "",
        label: "Tehsil",
        htmlFor: "tehsil",
        inputProps: {
          id: "tehsil",
          name: "tehsil",
          type: "select",
          options: [{ label: "Uttarakhand", value: "uttarakhand" }],
          disabled: false,
          required: true,
        },
      },
      {
        divClass: "",
        label: "District",
        htmlFor: "district",
        inputProps: {
          id: "district",
          name: "district",
          type: "select",
          options: [{ label: "Uttarakhand", value: "uttarakhand" }],
          disabled: false,
          required: true,
        },
      },
      {
        divClass: "",
        label: "Address Line 1",
        htmlFor: "address_line1",
        inputProps: {
          id: "address_line1",
          name: "address_line1",
          type: "text",
          placeholder: "Enter Address",
          disabled: false,
          required: true,
        },
      },
      {
        divClass: "",
        label: "Pin Code",
        htmlFor: "pin_code",
        inputProps: {
          id: "pin_code",
          name: "pin_code",
          type: "text",
          placeholder: "Enter Pin Code",
          disabled: false,
          required: true,
          maxLength: 6,
          validation: {
            required: true,
            pattern: /^[0-9]{6}$/,
            message: "Enter a valid 6-digit pin code.",
          },
        },
      },
      {
        divClass: "",
        label: "Aadhar Number",
        htmlFor: "aadhar_number",
        inputProps: {
          id: "aadhar_number",
          name: "aadhar_number",
          type: "text",
          placeholder: "Enter Aadhar Number",
          disabled: false,
          required: true,
          maxLength: 12,
          validation: {
            required: true,
            pattern: /^[0-9]{12}$/,
            message: "Enter a valid 12-digit Aadhar number.",
          },
        },
      },
      {
        divClass: "",
        label: "PAN Number",
        htmlFor: "pan_number",
        inputProps: {
          id: "pan_number",
          name: "pan_number",
          type: "text",
          placeholder: "Enter PAN Number",
          disabled: false,
          required: true,
          maxLength: 10,
          validation: {
            required: true,
            pattern: /^[A-Z]{5}[0-9]{4}[A-Z]{1}$/,
            message: "Enter a valid PAN number.",
          },
        },
      },
      {
        divClass: "",
        label: "Account Number",
        htmlFor: "account_number",
        inputProps: {
          id: "account_number",
          name: "account_number",
          type: "text",
          placeholder: "Enter Account Number",
          disabled: false,
          required: true,
          validation: {
            required: true,
            message: "Account number is required.",
          },
        },
      },
      {
        divClass: "",
        label: "Total Invoice Value",
        htmlFor: "invoice_value",
        inputProps: {
          id: "invoice_value",
          name: "invoice_value",
          type: "text",
          placeholder: "Enter Total Invoice Value",
          disabled: false,
          required: true,
        },
      },
      {
        divClass: "",
        label: "Amount Paid",
        htmlFor: "amount_paid",
        inputProps: {
          id: "amount_paid",
          name: "amount_paid",
          type: "text",
          placeholder: "Enter Amount Paid",
          disabled: false,
          required: true,
        },
      },
      {
        divClass: "",
        label: "Mode Of Payment (Chq/RTGS/Draft/Cash)",
        htmlFor: "payment_mode",
        inputProps: {
          id: "payment_mode",
          name: "payment_mode",
          type: "text",
          placeholder: "Enter Payment Mode",
          disabled: false,
          required: true,
        },
      },
      {
        divClass: "",
        label: "Payment Ref. No",
        htmlFor: "payment_ref_no",
        inputProps: {
          id: "payment_ref_no",
          name: "payment_ref_no",
          type: "text",
          placeholder: "Enter Payment Reference No",
          disabled: false,
          required: true,
        },
      },
      {
        divClass: "",
        label: "Date Of Payment",
        htmlFor: "payment_date",
        inputProps: {
          id: "payment_date",
          name: "payment_date",
          type: "date",
          placeholder: "Enter Payment Date",
          disabled: false,
          required: true,
          validation: {
            required: true,
            message: "Please select payment date.",
          },
        },
      },
    ],
  },
];
